export default __webpack_public_path__ + "static/media/ec1Open.83b3ee00.jpg";